module.exports = __webpack_public_path__ + "static/media/MobilePhoneGoogle-nz.b067d3e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/MobilePhoneGoogle-nz.png
// module id = 6160
// module chunks = 1